import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import {
  BorderType,
  ContentWidthEnum,
  PaddingType,
} from 'common/types/styleTypes'
import React, { ReactNode } from 'react'
import { WebsiteHeaderUi, WebsiteHeaderWrapperUi } from './ui'

export interface CommonWebsiteHeaderProps
  extends BackgroundColorInterface,
    BackgroundImageInterface {
  htmlAttrId: string
  children: ReactNode
  background?: BackgroundStylesInterface
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
  boxShadow?: string
}

export const CommonWebsiteHeader = ({
  htmlAttrId,
  contentWidth,
  padding,
  mobilePadding,
  children,
  ...rest
}: CommonWebsiteHeaderProps) => {
  return (
    <WebsiteHeaderUi {...rest}>
      <WebsiteHeaderWrapperUi
        padding={padding}
        mobilePadding={mobilePadding}
        contentWidth={contentWidth}
        id={htmlAttrId}
      >
        {children}
      </WebsiteHeaderWrapperUi>
    </WebsiteHeaderUi>
  )
}
